// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1079":"4c2db528","3015":"a781a379","3204":"fa9aa6e4","4225":"4c2db528","4595":"fa9aa6e4","6860":"7077dd31","7406":"ab728270","7999":"f06d8f54","8146":"8ec4144d"}[chunkId] + ".chunk.css";
};